import { ButtonHeading, CommonModal } from "components";
import BootstrapTable from "components/BootstrapTable";
import { getBannerlist } from "features";
import MastersFilterModal from "modals/MastersFilterModal";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { utils } from "helper";
import { UserContext } from "context";
import { UploadBannerModal } from "modals";
import { changeBannerStatusData, deleteBannerData } from "_services";

const Banner = () => {
  const dispatch = useDispatch();
  const { masterData } = useContext(UserContext);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showBannerModal, setShowBannerModal] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [editConsignerData, setEditConsignerData] = useState(null);
  const { data, loading } = useSelector((state) => state?.bannerData);
  const itemsPerPage = 10;
  const bannerList = data?.data?.banner;
  const totalCount = data?.data?.total_record;
  const [filter, setFilter] = useState({
    limit: 10,
    offset: 1,
    search: "",
    status: 1,
  });

  const [isDelete, setIsDelete] = useState(false);

  let addBannerModal = {
    isOpen: showBannerModal,
    closeModal: (e) => setShowBannerModal(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Banner",
    submitTitle: "Upload",
    cancelButtonTitle: "cancel",
    getBanner: (e) => getBanner(),
  };

  const { setMasterData, setUserData } = React.useContext(UserContext);

  // console.log("***********", bannerList);

  useEffect(() => {
    getBanner();
  }, [filter]);

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }));
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const currentPage = filter.offset;
    let pages = [];
    const createPageItem = (i) => (
      <li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
        <a className="page-link _avPointer" onClick={() => handlePageChange(i)}>
          {i}
        </a>
      </li>
    );

    const rangeStart = Math.max(2, currentPage - 2);
    const rangeEnd = Math.min(totalPages - 1, currentPage + 2);

    pages.push(createPageItem(1));

    if (rangeStart > 2) {
      pages.push(
        <li key="dots-before" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(createPageItem(i));
    }

    if (rangeEnd < totalPages - 1) {
      pages.push(
        <li key="dots-after" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (totalPages > 1) {
      pages.push(createPageItem(totalPages));
    }

    return (
      <ul className="pagination ">
        <li className={`page-item ${filter?.offset === 1 ? "disabled" : ""}`}>
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter?.offset - 1)}
          >
            <IoChevronBack />
          </a>
        </li>
        {pages}
        <li
          className={`page-item ${
            filter?.offset === totalPages ? "disabled" : ""
          }`}
        >
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter?.offset + 1)}
          >
            <IoChevronForward />
          </a>
        </li>
      </ul>
    );
  };

  const toggleOffcanvas = () => {
    setShowOffcanvas(!showOffcanvas);
    setEditConsignerData(null);
  };

  const columns = [
    { header: "", accessor: "serial" },
    { header: "Create Date & Time", accessor: "date_time" },
    { header: "Banner Image", accessor: "banner_img" },
    { header: "Status", accessor: "status" },
  ];

  // const deleteBanner = async (bannerId) => {
  //   try {
  //     const confirmed = window.confirm('Are you sure you want to delete this banner?');
  //     if (!confirmed) return;

  //     const payload = {
  //       banner_id: bannerId
  //     }

  //     const res = await dispatch(
  //       commonFetchFuction(
  //         async () => await deleteBannerData(payload),
  //         {},
  //         (res) => res // transformer
  //       )
  //     );

  //     console.log(res)

  //     if (res?.responseCode === 200) {
  //       getBanner();
  //       // toast.success(res?.responseMessage);
  //     } else {
  //       // toast.error(res?.responseMessage);
  //     }
  //   } catch (error) {
  //     // toast.error(error.message || 'Something went wrong');
  //   }
  // };

  const handleStatusEvent = async (data) => {
    try {
      const payload = {
        banner_id: data?._id,
        status: data?.status === 1 ? 0 : 1,
      };

      const res = await changeBannerStatusData(payload);
      if (res?.responseCode === 200) {
        getBanner();
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: (
        <React.Fragment>
          <div className="signDropdown">
            <button className="dropbtn11">
              <BsThreeDotsVertical />
            </button>
            <div className="dropdownContent">
              <Link
                // to={`/account/supplier/details/${item?._id}`}
                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <AiOutlineEye />
                  </span>
                  &nbsp; View
                </span>
              </Link>
              <Link className="_avPointer" style={{ textDecoration: "none" }}>
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <FiEdit />
                  </span>
                  &nbsp; Edit
                </span>
              </Link>
              {/* onClick={() => deleteBanner(item._id) */}
              <div className="_avPointer" onClick={() => handleDelete(item)}>
                <span className="_samAnchor">
                  <span className="deleteIcon_avt">
                    <FaRegTrashCan color="red" />
                  </span>
                  Delete
                </span>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),

      date_time: (
        <React.Fragment>
          {utils?.formatDateMonth(item?.createdAt)}
        </React.Fragment>
      ),

      banner_img: (
        <React.Fragment>
          <div className="imgSel_box">
            <img
              src={`${masterData?.s3_url}${item?.path}`}
              alt={item?.filename ? item?.filename : "-"}
            />
          </div>
        </React.Fragment>
      ),

      status: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "125px" }}
        >
          <input
            className="form-check-input"
            type="checkbox"
            name="actStatus"
            id={`actStatus-${item._id}`}
            autoComplete="off"
            checked={item?.status}
            onChange={(e) => handleStatusEvent(item)}
          />
          <span
            className={
              item?.status
                ? "active_label_masters_status"
                : "disabled_label_masters_status"
            }
          >
            {item?.status ? "Active" : "Disabled"}
          </span>
        </div>
      ),
    }));
  };

  const commonFetchFuction = async (
    apiMethod,
    payload = {},
    transformer = (res) => res
  ) => {
    try {
      const res = await apiMethod(payload);

      if (res?.responseCode === 200) {
        getBanner();
        // toast.success(res?.responseMessage);
      } else {
        // toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const getBanner = async () => {
    const payload = {
      limit: filter?.limit,
      offset: filter?.offset,
    };

    try {
      const res = await dispatch(getBannerlist(payload));

      if (res.payload?.responseCode === 200) {
      }
    } catch (error) {
      throw error;
    }

    // const res = await dispatch(commonFetchFuction(getComapnyList,payload))
  };

  const handleDelete = (item) => {
    setIsDelete(item);
  };

  const submitDeleteBanner = async () => {
    const payload = {
      banner_id: isDelete?._id,
    };
    try {
      const res = await deleteBannerData(payload);
      if (res?.responseCode == 200) {
        toast.success(res?.responseMessage);
        setIsDelete(false);
        getBanner();
      } else {
        toast.success("Error !! ");
      }
    } catch (error) {
      throw error;
    }
  };

  let propsObject = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(!isDelete),
    modalMainClass: "confirmModal_new",
    footerPart: true,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: submitDeleteBanner,
    isLoadding: loading,
  };

  return (
    <>
      <ButtonHeading
        title={"Banner"}
        // onClick={toggleOffcanvas}
        onClick={() => setShowBannerModal(!showBannerModal)}
        buttonTitle="Add Banner"
        // showSearchFilter={{ search: true, filterOption: true, filterCount: true }}
        onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
        filter={filter}
        setFilter={setFilter}
      />

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(bannerList?.length > 0 ? bannerList : [])}
          tablelMainClass="bannerTable"
          // isLoading={loading}
        />

        <div className="paginationFt_avt">{renderPagination()}</div>
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showFilterModal ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {showBannerModal && <UploadBannerModal {...addBannerModal} />}

      {/* {
        isDelete?._id && (
        )
      } */}
      <CommonModal {...propsObject}>
        <p className="p-3"> Do you really want to delete this banner ? </p>
      </CommonModal>
    </>
  );
};

export default Banner;
